import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle } from '@fortawesome/pro-solid-svg-icons';

import { activityTypes } from './config';

import './styles.scss';

export default function ActivityTypeIcon({ activityType, circled, className, style }) {
  const config = activityTypes[activityType];
  const wrapperClassName = classNames('apex-activity-type-icon', config.key, className);

  if (circled) {
    return (
      <div className={`${wrapperClassName} circled fa-stack`} style={style}>
        <FontAwesomeIcon className="fa-stack-2x circle" icon={faCircle} />
        <FontAwesomeIcon className="fa-stack-1x icon" icon={config.icon} size="xs" />
      </div>
    );
  } else {
    return <FontAwesomeIcon className={wrapperClassName} icon={config.icon} style={style} />;
  }
}

ActivityTypeIcon.propTypes = {
  activityType: PropTypes.oneOf(Object.keys(activityTypes)),
  circled: PropTypes.bool,
  className: PropTypes.string,
};
